import React from "react";

function Stage3() {
  return (
    <>
    {/* <div className="stylesheetpage-container">
      <div className="stylesheetpage-box"> */}
        <h2 className="stylesheetpage-title">Secondary (Key Stage 3)</h2>
        <p className="stylesheetpage-text">
          <b>
            <u>Grades 6, 7 and 8.</u>
          </b>
          <br />
          These three grades follow the Cambridge Secondary 1 curricula which
          provide a seamless progression from Primary and further develop skills
          and confidence in students for all subjects. It offers a curriculum
          framework for educational success for students, typically 11-14 years
          old, with an integrated testing structure. The syllabus is progressive
          in each subject from Grade 6 to Grade 8 and prepares the learner for
          the Secondary 2 Level – IGCSE.
          <br />
          Subjects being offered in these Grades are mentioned below. All
          subjects are compulsory if not categorized otherwise.
        </p>
        <ul>
          <li>English</li>
          <li>Mathematics</li>
          <li>Science</li>
          <li>Information and Computer Technology – ICT</li>
          <li>Mandarin (Grades 6 – 8)</li>
          <li>
            Urdu as a Second Language (Compulsory for all Pakistani Dual
            National students who will spend more than 03 years in Pakistan by
            the time they complete A Level.
          </li>
          <li>Easy Urdu (Refer to Easy Urdu description)</li>
          <li>Islamiyat (Compulsory for all Muslim Students)</li>
          <li>Geography (Grades 6 – 7 Only)</li>
          <li>History (Grades 6- 7 Only)</li>
          <li>
            Pakistan Studies 1: The History and Culture of Pakistan – CIE IGCSE
            0448/1 (Grade 8)
          </li>
          <li>
            Pakistan Studies 2: The Environment of Pakistan – CIE IGCSE 0448/2
            (Grade 8)
          </li>
          <li>Art and Design</li>
          <li>Physical Education</li>
        </ul>
        <p className="stylesheetpage-text">
          For detailed syllabus content for each subjects in each grade please
          contact Head; Secondary / A Level Section through Academy Frontdesk.
        </p>
        <p className="stylesheetpage-text">
          <strong>Easy Urdu</strong>
          <br />
          Students of Grades 1 – 7 will have the opportunity of studying Easy
          Urdu if coming from overseas; and are absolutely unfamiliar with the
          language. Students of G 1 – 6 will be allowed to take up the subject
          for a maximum period of two (02) years and students of Grade 7 for a
          maximum of one (01) year.
          <br />
          After the stipulated period, students availing the facility of
          studying Easy Urdu will not be allowed to continue with Easy Urdu.
          They will be required to take up Regular Urdu along with the other
          students of their class.
          <br />
          In grade 8 Easy Urdu will be offered to students who will not sit for
          CIE IGCSE Urdu as a Second Language in Grade 9.
          <br />
          (N.B: Please refer to IBCC Equivalence Policy)
        </p>
      {/* </div>
    </div> */}
    </>
  );
}

export default Stage3;
